export default __webpack_public_path__ + "static/media/dollar.c8ef9997.png";